module.exports = __webpack_public_path__ + "files/07c9efdc0805f14fb8cf02757f42a8a5.png";